import identityApiClient from '../../../services/identity-api-client'
import type { ZealysLogin, LoginInternalAccess, GrantAccessRequest } from '../types/internal-access.types'

export async function getZealysLogins(): Promise<ZealysLogin[]> {
  const response = await identityApiClient.get<ZealysLogin[]>('/api/logininternalaccess/zealys-logins')
  return response.data
}

export async function getLoginInternalAccess(loginId: string): Promise<LoginInternalAccess[]> {
  const response = await identityApiClient.get<LoginInternalAccess[]>(`/api/logininternalaccess/login/${loginId}`)
  return response.data
}

export async function grantAccess(request: GrantAccessRequest): Promise<{ message: string }> {
  const response = await identityApiClient.post<{ message: string }>('/api/logininternalaccess/grant', request)
  return response.data
}

export async function deleteAccess(id: string): Promise<void> {
  await identityApiClient.delete(`/api/logininternalaccess/${id}`)
}

export async function updateAccess(id: string, request: GrantAccessRequest): Promise<LoginInternalAccess> {
  const response = await identityApiClient.put<LoginInternalAccess>(`/api/logininternalaccess/${id}`, request)
  return response.data
}
